// previewChrome — one flag that hides ALL Vella chrome while an expanded
// website preview is open (D10). The expanded preview is a full-bleed layer
// at z-index:40; the app's floating chrome (chat bar, orb, chips, FABs, help
// button, edit-toolbar dock) must not float on top of it.
//
// Mechanism: toggle a `vella-preview-expanded` class on <body> and inject a
// one-time <style> that display:none-s anything tagged `[data-vella-chrome]`
// plus the fixed LivingOrb (`.vella-orb`). Components opt in by adding
// `data-vella-chrome` to their fixed/floating root.
//
// Cheap, framework-agnostic, and reversible — callers pair setPreviewExpanded
// (true) on open with (false) on close/unmount.

const STYLE_ID = 'vella-preview-expanded-css';
const BODY_CLASS = 'vella-preview-expanded';

const CSS = `
body.${BODY_CLASS} [data-vella-chrome],
body.${BODY_CLASS} .vella-orb { display: none !important; }
`;

function ensureStyle() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = CSS;
  document.head.appendChild(el);
}

export function setPreviewExpanded(on) {
  if (typeof document === 'undefined' || !document.body) return;
  ensureStyle();
  document.body.classList.toggle(BODY_CLASS, !!on);
}

export default setPreviewExpanded;
